export default "__VITE_ASSET__DZqEGOUy__"